import {
  Component,
  Input,
  OnDestroy,
  ViewEncapsulation,
  inject,
  input,
} from '@angular/core';
import {
  Router,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError,
} from '@angular/router';
import { DOCUMENT } from '@angular/common';

// others
import { Spinkit } from './spinkits';
@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: [
        './spinner.component.css',
        './spinkit-css/sk-double-bounce.css',
        './spinkit-css/sk-chasing-dots.css',
        './spinkit-css/sk-cube-grid.css',
        './spinkit-css/sk-rotating-plane.css',
        './spinkit-css/sk-spinner-pulse.css',
        './spinkit-css/sk-three-bounce.css',
        './spinkit-css/sk-wandering-cubes.css',
        './spinkit-css/sk-wave.css',
        './spinkit-css/sk-line-material.css'
    ],
    encapsulation: ViewEncapsulation.None,
    imports: []
})
export class SpinnerComponent implements OnDestroy {
  private router = inject(Router);

  public Spinkit = Spinkit;
  public readonly backgroundColor = input('#4caf50');
  public readonly spinner = input(Spinkit.skLine);
  public readonly type = input('route');
  @Input() public isSpinnerVisible = true;
  private sub: any;
  constructor() {
    if (this.type() === 'route') {
      this.router.events.subscribe(event => {
        if (event instanceof NavigationStart) {
          this.isSpinnerVisible = true;
        } else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
          this.isSpinnerVisible = false;
        }
      }, (error: any) => {
        this.isSpinnerVisible = false;
      });
    }
  }

  private _document?: Document;

  ngOnDestroy(): void {
    this.isSpinnerVisible = false;
  }
}
